<template>
  <div class="toViewActive">
    <el-dialog
      title="查看"
      :close-on-click-modal="false"
      :visible.sync="dialogActivityDateVisible"
      append-to-body
      class="dialogActivityDateVisible"
    >
      <div class="dialogContent">
        <div class="titleTop">集采活动基础信息</div>
        <div class="dialogContent_box">
          <div class="box_mess">
            <p>集采活动名称：</p>
            <p>{{ form.activityName }}</p>
          </div>
          <div class="box_mess">
            <p>集采活动状态：</p>
            <p>{{ form.activityProcesseCn }}</p>
          </div>
          <div class="box_mess">
            <p>集采活动时间：</p>
            <p>{{ form.startTime+' 至 '+ form.endTime }}</p>
          </div>
        </div>
        <div class="dialogContent_box">
           <!--<div class="box_mess">-->
            <!--<p>活动广告图：</p>-->
            <!--<img :src="form.adUrl" alt="">-->
          <!--</div>-->
           <div class="box_mess">
            <p>集采活动banner：</p>
            <img :src="form.bannerUrl" alt="">
          </div>
        </div>
        <div class="titleTop">集采活动详情</div>
        <div style="margin: 0 50px;display: flex;">
          <p style="white-space: nowrap;">集采活动说明：</p>
          <p v-html="form.activityContent" class="vHtmlMess" style="margin-top: 3px;"></p>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
    import { getActivitiesDetails } from '../../../utils/interface';
export default {
  name: "toViewActive",
  data() {
    return {
        form:{},
      dialogActivityDateVisible: false
    };
  },
  methods:{
    init(uuid){
        getActivitiesDetails(uuid).then((res)=>{
            this.form = res.data;
        });
      this.dialogActivityDateVisible = true
    },
  }
};
</script>

<style lang="less" scoped>
.toViewActive {
  .dialogActivityDateVisible {
    /deeep/.el-dialog__body {
      padding-left: 30px !important;
      padding-right: 30px !important;
    }
  }
}
  .dialogContent {
    .titleTop {
      font-size: 20px;
      margin-bottom: 26px;
      padding-left: 48px;
      border-top: 1px solid #efefef;
      padding-top: 30px;
      &:nth-of-type(1) {
        border-top: none;
        padding-top: 0;
      }
    }
  }
  .dialogContent_box {
    // display: flex;
    // flex-wrap: wrap;
    margin: 0 50px;
    .box_mess {
      // width: 50%;
      display: flex;
      margin-bottom: 15px;
      p:nth-of-type(1) {
        white-space: nowrap;
      }
      img {
        width: 200px;
        height: 130px;
      }
    }
  }
  .box_mess2 {
      display: flex;
          margin: 0 50px;
    }
</style>



// WEBPACK FOOTER //
// src/views/collectManage/collectDialog/toViewActive.vue